import icons, { iconTypes } from 'utils/icons';
import PropTypes from 'prop-types'

const sharedPropTypes = {
    icon: PropTypes.oneOf(Object.values(icons)),
    iconType: PropTypes.oneOf(Object.keys(iconTypes)),
};

export default sharedPropTypes;